// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_dynamic-form_containers_dynamic-form_dynamic-form_component_ts-src_app_dynami-5a7bf7":"10b18682f0e61575","src_app_competitions_competitions_module_ts":"9b3e118095a5fb94","src_app_courses_courses_module_ts":"6370441a6a79cf90","src_app_users_users_module_ts":"ec4ed5dd274b5fba"}[chunkId] + ".js";
};